import React, { useState } from 'react';
import Cake from '../../../assets/images/No-Image.jpg';
import '../itemCard.css';
import { useNavigate } from 'react-router';
import './category.css';

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

const CategoryCardEdit = ({ val, handleMenuClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  const truncatedAddress = val?.name?.length > 20 ? val?.name.substring(0, 30) + '...' : val?.name;

  const handleClick = () => {
    handleMenuClick(val);
  };

  return (
    <div className="category-card-wrapper">
      <div
        className="catCard-improved"
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          transform: isHovered ? 'translateY(-4px)' : 'translateY(0)',
        }}
      >
        <div className="category-content">
          <div className="image-container">
            <div className="image-wrapper">
              <img className="category-image" src={val?.imageUrl === null ? Cake : IMAGE_URL + val?.imageUrl} />
              <div className="image-overlay"></div>
            </div>
          </div>

          <div className="category-info">
            <h6 className="category-title" title={val?.name}>
              {truncatedAddress || '--'}
            </h6>
            <div className="category-subtitle">Tap to explore</div>
          </div>

          <div className="category-arrow">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        </div>

        <div className="card-shine"></div>
      </div>
    </div>
  );
};

export default CategoryCardEdit;
